import React from "react";
import { FaSignOutAlt } from "react-icons/fa";
import { leaveRoom } from "../../utils/wss";

const LeaveRoomButton = () => {
  const handleRoomDisconnection = () => {

    leaveRoom();

    // Redirect to home or login page
    window.location.href = window.location.origin;
  };

  return (
    <div className="video_button_container" onClick={handleRoomDisconnection}>
      <FaSignOutAlt className="video_button_icon" />
    </div>
  );
};

export default LeaveRoomButton;
